// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResultUser__content-de4a52 {
  display: flex;
  flex-direction: column;
  margin-inline-start: var(--indent-16px);
  justify-content: space-between;
  flex-grow: 1;
  overflow: hidden;
}

.SearchResultUser__header-wrapper-d2c92b {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.SearchResultUser__top-c0ed52 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.SearchResultUser__header-ba219e {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
}

.SearchResultUser__bottom-d6871c {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
}

.SearchResultUser__description-e0e5d6 {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SearchResult/SearchResultItem/SearchResultUser/SearchResultUser.style.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAAF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  margin-inline-start: var(--indent-16px);\n  justify-content: space-between;\n  flex-grow: 1;\n  overflow: hidden;\n}\n\n.header-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.header {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n\n  word-break: break-all;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 24px;\n}\n\n.description {\n  word-break: break-all;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  min-width: 0;\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `SearchResultUser__content-de4a52`,
	"header-wrapper": `SearchResultUser__header-wrapper-d2c92b`,
	"headerWrapper": `SearchResultUser__header-wrapper-d2c92b`,
	"top": `SearchResultUser__top-c0ed52`,
	"header": `SearchResultUser__header-ba219e`,
	"bottom": `SearchResultUser__bottom-d6871c`,
	"description": `SearchResultUser__description-e0e5d6`
};
module.exports = ___CSS_LOADER_EXPORT___;
